export function VerifyingStep() {
  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <div className="iris-spinner" />
      <div style={{ marginTop: 12 }}>Linked. Reading group list…</div>
    </div>
  );
}
